// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// shared components
import { SuperuserOnly } from '@/components/access-control';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary.tsx';

// TODO find a better way to handle this guard
function AdminLayout() {
  return (
    <SuperuserOnly>
      <Suspense>
        <Outlet />
      </Suspense>
    </SuperuserOnly>
  );
}

export const Route = createFileRoute('/$accountId/_admin')({
  component: AdminLayout,
  errorComponent: ErrorBoundary,
});
